import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getPDF } from '../network/salesInvoice';
import { message } from 'antd';
import { useState } from 'react';

const UseDownloadPdf = () => {
  const client = useQueryClient();
  const [loadingPdf, setLoadingPdf] = useState(false);
  const { mutate: onGetPDF, data: pdfData } = useMutation({
    mutationKey: ['getPDF'],
    mutationFn: ({ type, name, lang, format }) =>
      getPDF({ type, name, lang, format }),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoadingPdf(false);
      // console.log(data?.message, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      // const url = window.URL.createObjectURL(new Blob([data?.data], { type: 'application/pdf' }));
      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', 'invoice.pdf');
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);

      // console.log('PDF downloaded successfully', link.href);
    },
    onError: (error) => {
      message.error(error);
      setLoadingPdf(false);
    },
  });

  return { onGetPDF, pdfData, setLoadingPdf, loadingPdf };
};

export default UseDownloadPdf;
